// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"e81ad6f4","453":"92a723c4","796":"ed77b010"}[chunkId] + ".chunk.js";
};